import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import vw from 'src/styles/utils';

function Checkbox(props) {
  const { label, gridArea, id, required } = props;

  return (
    <Root gridArea={gridArea} htmlFor={id}>
      <input
        type="checkbox"
        required={required}
        id={id}
        value="YES"
      />
      <span />
      {label}
    </Root>
  )
}

Checkbox.propTypes = {
  label: PropTypes.string,
  gridArea: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.string
}

const Root = styled.label`
  display: flex;
  grid-area: ${props => props.gridArea};
  font-family: Big Caslon;
  font-style: normal;
  font-weight: normal;
  color: #000000;
  position: relative;
  cursor: pointer;
  ${vw('font-size', 11)}
  ${vw('line-height', 13, 16)}
  ${vw('letter-spacing', 0.06)}
  ${vw('margin-top', 20, 20)}
  ${vw('padding-left', 43, 30)}

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #E1E1E1;
    box-sizing: border-box;
    ${vw('width', 30, 20)}
    ${vw('height', 30, 20)}

    &::after {
      display: none;
      content: "";
      position: absolute;
      border: solid #DE5647;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
      ${vw('left', 10, 5)}
      ${vw('top', 2)}
      ${vw('width', 7, 5)}
      ${vw('height', 15, 10)}
    }
  }

  &:hover input ~ span {
    background-color: #ccc;
  }

  input:checked ~ span {
    background-color: white;
  }

  input:checked ~ span:after {
    display: block;
  }
`;

export default Checkbox

